import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

function dm_a02() {

    gsap.registerPlugin(ScrollTrigger);
    function reset_scroll_triggers(){
        $(window).trigger('resize');
        // ScrollTrigger.killAll();
        ScrollTrigger.refresh(true);
    }
    reset_scroll_triggers();

    const body = document.querySelector('body');
    const $h2 = $('.a02-animate');
    let direction = 1;
    let pos = 0;

    function animate() {
        pos += direction * 0.5;
        if (pos > 30 || pos < 0) direction *= -1;
        $h2.css('transform', `translateX(${pos}px)`);
        requestAnimationFrame(animate);
    }

    animate();

};

export { dm_a02 };